import React from 'react';
import { Lock } from 'lucide-react';

export const StaffLogin = () => {
  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/staff';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen pt-32 pb-20 px-4" data-testid="staff-login">
      <div className="max-w-md mx-auto bg-white rounded-2xl shadow-xl p-10 text-center">
        <div className="bg-blue-100 text-blue-700 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
          <Lock size={30} />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-3">Staff Sign-In</h1>
        <p className="text-gray-600 mb-8">For authorized Community Medical Center staff only.</p>
        <button
          onClick={signIn}
          data-testid="staff-google-signin-btn"
          className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
        >
          Sign in with Google
        </button>
      </div>
    </div>
  );
};
